<template>
  <main class="home bg-darken">
    <!-- Theme Header -->
    <ThemeHeader />

    <!-- Hero Banner -->
    <section
      class="hero-banner-wrapper relative bg-no-repeat bg-cover"
      :style="[{backgroundImage: 'url('+bannerBg+')'}]"
    >
      <div class="wrapper max-w-1440px ml-auto mr-auto xl:px-0 lg:px-0 md:px-spc2">
        <HeroBanner
          :title="bannerTitle"
          :desc="bannerDesc"
          :btn1title="bannerBtn1Title"
          :btn1url="bannerBtn1url"
          :btn2title="bannerBtn2Title"
          :btn2url="bannerBtn2url"
        />

        <!-- Review Box -->
        <ReviewBox />
      </div>
    </section>

    <!-- Services -->
    <section class="service-wrapper relative bg-darken">
      <div class="wrapper max-w-1440px ml-auto mr-auto xl:px-0 lg:px-0 md:px-spc2">
        <div class="max-w-635px">
          <SectionHeading
            title="Your Buyers are in the Driver's Seat and Sales Enablement is your Road to Success"
            content="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero"
          />
        </div>
        <ServiceOne />
      </div>
    </section>

    <!-- How It Work -->
    <section
      class="hiw-wrapper relative bg-darken pt-spc25 xl:pb-spc30 lg:pb-spc30 pb-spc30 md:pb-0"
    >
      <div class="wrapper max-w-1440px ml-auto mr-auto xl:px-spc22 lg:px-spc22 px-spc22 md:px-0">
        <HowItWork />
      </div>
    </section>

    <!-- Delivery -->
    <section
      class="delivery-wrapper relative bg-cover bg-no-repeat xl:pt-spc28 lg:pt-spc28 pt-spc28 md:pt-spc64 pb-spc29"
      :style="[{backgroundImage: 'url('+deliveryBg+')'}]"
    >
      <div class="wrapper max-w-1440px ml-auto mr-auto xl:px-0 lg:px-0 md:px-spc2">
        <div
          class="delivery-content-box xl:max-w-586px lg:max-w-586px max-w-586px md:max-w-none ml-auto"
        >
          <Delivery
            :title="deliveryTitle"
            :desc="deliveryDesc"
            :btntitle="deliveryBtn"
            :btnurl="deliveryBtnUrl"
          />
        </div>
      </div>
    </section>

    <!-- Zippykind -->
    <Zippykind zippykindList="zippykingitem" />

    <!-- Industry -->
    <section class="industry-wrapper relative overflow-hidden pb-spc43">
      <div class="wrapper max-w-1440px ml-auto mr-auto xl:px-0 lg:px-0 md:px-spc2">
        <div
          class="industry-content-flex flex xl:flex-row lg:flex-row flex-row md:flex-col items-start"
        >
          <div class="left w-full max-w-530px flex-none mr-20">
            <SectionHeading
              title="Your Industry - our Sales Enablement Platform:"
              content="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita."
            />
            <ThemeButton
              title="Learn More"
              url="#"
              class="theme-border-btn opacity-90 border-solid mt-spc35"
            />
          </div>
          <div class="right w-full xl:mt-spc36 lg:mt-spc36 mt-spc36 md:mt-spc33">
            <slick :options="slickOptions">
              <IndustrySlider
                :industries="industries"
                v-for="(industries, i ) in industrySliderDatas.industrySliderItem"
                :key="i"
              />
            </slick>
          </div>
        </div>
      </div>
    </section>

    <!-- Key Features -->
    <section class="keyfeatures-wrapper overflow-hidden pb-spc46">
      <div class="wrapper max-w-1440px ml-auto mr-auto overflow-hidden xl:px-0 lg:px-0 md:px-spc2">
        <KeyFeatures />
      </div>
    </section>

    <!-- Store -->
    <section class="download-store-wrapper pb-spc56 overflow-hidden">
      <div class="wrapper max-w-1440px ml-auto mr-auto xl:pl-spc40 lg:pl-spc40 pl-spc40 md:px-0">
        <DownloadStore />
      </div>
    </section>

    <!-- pricing Table -->
    <section class="pricing-wrapper pb-spc31">
      <div class="wrapper max-w-1440px ml-auto mr-auto px-spc34">
        <div class="text-center max-w-465px ml-auto mr-auto">
          <SectionHeading
            title="Pricing Plans"
            content="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et."
          />
          <div
            class="pricing-toggle flex items-center text-white text-center justify-center mt-spc54"
          >
            <div
              :class="{'active': pricingVisible}"
              class="pricing-toggle-btn w-spc52 h-spc53 mr-8 relative cursor-pointer"
              @click="pricingToggler"
            ></div>
            <span class="block opacity-50">Pricing with Mentoring and Support</span>
          </div>
        </div>

        <div class="pricing-tab mt-spc55">
          <div
            v-show="pricingVisible"
            class="pricing-box-flex flex xl:flex-no-wrap lg:flex-no-wrap flex-no-wrap md:flex-wrap xl:flex-row lg:flex-row flex-row md:flex-col items-start"
          >
            <PricingBox
              :pricingProps="pricingPlan"
              v-for="(pricingPlan, i) in pricingPlanData.pricingplans2"
              :key="i"
            />
          </div>
          <div
            v-if="!pricingVisible"
            class="pricing-box-flex flex xl:flex-no-wrap lg:flex-no-wrap flex-no-wrap md:flex-wrap xl:flex-row lg:flex-row flex-row md:flex-col items-start"
          >
            <PricingBox
              :pricingProps="pricingPlan"
              v-for="(pricingPlan, i) in pricingPlanData.pricingplans"
              :key="i"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- cta -->
    <section
      class="delivery-wrapper delivery-2 relative bg-cover bg-no-repeat xl:pt-spc28 lg:pt-spc28 pt-spc28 md:pt-spc67 pb-spc29"
      :style="[{backgroundImage: 'url('+deliveryBg2+')'}]"
    >
      <div class="wrapper max-w-1440px ml-auto mr-auto xl:px-0 lg:px-0 md:px-spc2">
        <div class="delivery-content-box max-w-586px">
          <Delivery
            :title="deliveryTitle2"
            :desc="deliveryDesc2"
            :btntitle="deliveryBtn2"
            :btnurl="deliveryBtnUrl2"
          />
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="footer-wrapper xl:pt-spc59 lg:pt-spc59 pt-spc59 md:pt-spc33">
      <div class="wrapper max-w-1440px ml-auto mr-auto xl:px-0 lg:px-spc2 md:px-spc2">
        <ThemeFooter />

        <div class="copyright-wrapper pt-spc35 mt-spc57 pb-spc60">
          <div class="copyright-flex flex items-center justify-between">
            <div class="left">
              <Copyright title="SaaS On Demand Inc. 2020" />
            </div>
            <div class="right">
              <div class="copyright-select-boxes flex items-center">
                <div class="language-select mr-spc2">
                  <span class="block footer-select relative">
                    <span class="select-icon text-white opacity-50 absolute">
                      <font-awesome-icon :icon="['fa', 'angle-down']" />
                    </span>
                    <select
                      name="counter"
                      id="country"
                      class="uppercase bg-transparent text-base opacity-90 text-white tracking-spc1 h-spc12 px-spc2"
                    >
                      <option value="0">English</option>
                      <option value="1">Deutsch</option>
                      <option value="2">Espanol</option>
                      <option value="3">Francals</option>
                      <option value="4">Italino</option>
                      <option value="5">Portugues</option>
                    </select>
                  </span>
                </div>
                <div class="usd-select">
                    <span class="block footer-select relative w-spc68">
                        <span class="select-icon text-white opacity-50 absolute">
                          <font-awesome-icon :icon="['fa', 'angle-down']" />
                        </span>
                        <select
                          name="usd"
                          id="usd"
                          class="uppercase w-full bg-transparent text-base opacity-90 text-white tracking-spc1 h-spc12 px-spc2"
                        >
                          <option value="0">Usd</option>
                          <option value="1">Eur</option>
                          <option value="2">Aud</option>
                          <option value="3">Gbp</option>
                          <option value="4">Cad</option>
                        </select>
                    </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </main>
</template>

<script>
import HeroBanner from "../components/sections/banner/HeroBanner";
import ThemeHeader from "../components/common/ThemeHeader";
import ReviewBox from "../components/sections/review/ReviewBox";
import ServiceOne from "../components/sections/services/service1/ServiceOne";
import SectionHeading from "../components/common/SectionHeading";
import HowItWork from "../components/sections/services/how-it-work/HowItWork";
import Delivery from "../components/sections/services/delivery/Delivery";
import Zippykind from "../components/sections/services/delivery/Zippykind";
import IndustrySlider from "../components/sliders/IndustrySlider";
import ThemeButton from "../components/common/ThemeButton";
import Slick from "vue-slick";
// Slick Slider
import "slick-carousel/slick/slick.css";
import KeyFeatures from "../components/sections/services/keyfeatures/KeyFeatures";
import DownloadStore from "../components/sections/store/DownloadStore";
import PricingBox from "../components/common/PricingBox";
import ThemeFooter from "../components/common/ThemeFooter";
import Copyright from "../components/common/Copyright";

/* industry */
let industrySliderDatas = {
  industrySliderItem: [
    {
      img: require("@/assets/images/industry-1.jpg"),
      title: "Life Sciences"
    },
    {
      img: require("@/assets/images/industry-2.jpg"),
      title: "Telecommunication"
    },
    {
      img: require("@/assets/images/industry-3.jpg"),
      title: "Financial"
    },
    {
      img: require("@/assets/images/industry-4.jpg"),
      title: "Technology"
    },
    {
      img: require("@/assets/images/industry-5.jpg"),
      title: "Retail"
    },
    {
      img: require("@/assets/images/industry-6.jpg"),
      title: "Manufacturing"
    },
    {
      img: require("@/assets/images/industry-7.jpg"),
      title: "Energy"
    },
    {
      img: require("@/assets/images/industry-8.jpg"),
      title: "GovernmentApp"
    }
  ]
};

/* pricing plan */
let pricingPlanData = {
  pricingplans: [
    {
      price: "99",
      offer: "",
      title: "Basic Package",
      content:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna.",
      features: [
        {
          title: "Basic Special Feature I"
        },
        {
          title: "Basic Special Feature II"
        },
        {
          title: "Basic Special Feature III"
        },
        {
          title: "Basic Special Feature IV"
        },
        {
          title: "Basic Special Feature V"
        }
      ]
    },
    {
      price: "180",
      offer: "Special Offer",
      title: "Standard Package",
      content:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna.",
      features: [
        {
          title: "Standard Special Feature I"
        },
        {
          title: "Standard Special Feature II"
        },
        {
          title: "Standard Special Feature III"
        },
        {
          title: "Standard Special Feature IV"
        },
        {
          title: "Standard Special Feature V"
        }
      ]
    },
    {
      price: "499",
      offer: "",
      title: "Premium Package",
      content:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna.",
      features: [
        {
          title: "Premium Special Feature I"
        },
        {
          title: "Premium Special Feature II"
        },
        {
          title: "Premium Special Feature III"
        },
        {
          title: "Premium Special Feature IV"
        },
        {
          title: "Premium Special Feature V"
        }
      ]
    }
  ],
  pricingplans2: [
    {
      price: "88",
      offer: "",
      title: "Basic Package",
      content:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna.",
      features: [
        {
          title: "Basic Special Feature I"
        },
        {
          title: "Basic Special Feature II"
        },
        {
          title: "Basic Special Feature III"
        },
        {
          title: "Basic Special Feature IV"
        },
        {
          title: "Basic Special Feature V"
        }
      ]
    },
    {
      price: "160",
      offer: "Special Offer",
      title: "Standard Package",
      content:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna.",
      features: [
        {
          title: "Standard Special Feature I"
        },
        {
          title: "Standard Special Feature II"
        },
        {
          title: "Standard Special Feature III"
        },
        {
          title: "Standard Special Feature IV"
        },
        {
          title: "Standard Special Feature V"
        }
      ]
    },
    {
      price: "399",
      offer: "",
      title: "Premium Package",
      content:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna.",
      features: [
        {
          title: "Premium Special Feature I"
        },
        {
          title: "Premium Special Feature II"
        },
        {
          title: "Premium Special Feature III"
        },
        {
          title: "Premium Special Feature IV"
        },
        {
          title: "Premium Special Feature V"
        }
      ]
    }
  ]
};

export default {
  name: "Home",
  components: {
    Copyright,
    ThemeFooter,
    PricingBox,
    DownloadStore,
    KeyFeatures,
    ThemeButton,
    IndustrySlider,
    Zippykind,
    Delivery,
    HowItWork,
    SectionHeading,
    ServiceOne,
    ReviewBox,
    ThemeHeader,
    HeroBanner,
    Slick
  },
  data() {
    return {
      bannerTitle: "Everything that you need \nto run your",
      bannerDesc:
        "Lorem ipsum dolor sit amet, consetetur sadipscing\n elitr, sed diam nonumy eirmod tempor invidunt ut\n labore et dolore magna aliquyam erat, sed diam",
      bannerBtn1Title: "NO COMMITMENT 14 DAY TRIAL",
      bannerBtn2Title: "PRODUCT TOUR",
      bannerBtn1url: "#",
      bannerBtn2url: "#",
      bannerBg: require("@/assets/images/banner-bg.jpg"),
      deliveryBg: require("@/assets/images/delivery-bg.jpg"),
      deliveryBg2: require("@/assets/images/delivery-bg-2.jpg"),
      deliveryTitle: "Manage your Delivery Business with Ease",
      deliveryDesc:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit.",
      deliveryBtn: "Learn More",
      deliveryBtnUrl: "#",
      deliveryTitle2: "The ultimate suite to grow your business",
      deliveryDesc2:
        "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit.",
      deliveryBtn2: "Learn More",
      deliveryBtnUrl2: "#",
      industrySliderDatas,
      pricingPlanData,
      pricingVisible: false
    };
  },
  methods: {
    pricingToggler() {
      this.pricingVisible = !this.pricingVisible;
    }
  },
  computed: {
    slickOptions() {
      return {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        variableWidth: true,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {}
          },
          {
            breakpoint: 1008,
            settings: {}
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              infinite: false,
              draggable: true,
              variableWidth: true,
              centerMod: true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              infinite: false,
              draggable: true,
              variableWidth: true,
              centerMod: true
            }
          }
        ]
      };
    }
  }
};
</script>

<style scoped>
</style>